<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FU5te6/tc-custom/9781514000694.jpg?1696024624568" alt="This image is the cover for the book Freeing Congregational Mission"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Freeing Congregational Mission
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>There is a deepening crisis in mission as practiced by North American congregations.</strong> Many mission activities are more effective at satisfying church members than making a lasting difference, producing what's too often consumer-oriented "selfie mission." Too much effort is based on colonial-era assumptions of mission launched from a position of power. These practices are not just ineffective—they deviate from mission in the way of Jesus. Hunter Farrell and Bala Khyllep want to help free congregational mission from harmful cultural forces so churches can better partner with God's work in the world. They invite leaders to lay the foundation for more faithful and effective missions with three core elements:</p>  a Christ-centered theology of mission rooted in <em>companionship</em>  an appetite and competence to engage across differences with <em>cultural humility</em>  insights and strategies to accompany local and global neighbors in <em>co-development</em> <p>Farrell and Khyllep deliver key takeaways from the latest mission research, inspiring examples from innovative congregations, and a set of step-by-step tools for churches to discern and implement sound practices that will work for them. The local church community is well-positioned to build a spreading circle of relationships centered in Jesus Christ. With this book, congregations of every Christian tradition will find practical help to direct their resources in truly life-giving ways as they seek the mission of God.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        B. Hunter Farrell, S. Balajiedlang Khyllep
      </h2>
      
      <p class="authorDescription body article"><p> B. Hunter Farrell (doctor of anthropology, Pontificia Universidad Católica del Perú) is the director of Pittsburgh Theological Seminary's World Mission Initiative (WMI). He has worked for over thirty years as a missionary, director of world mission for the Presbyterian Church (U.S.A.), and a professor of mission and intercultural studies. He has published articles in periodicals including <em>Missiology</em>, <em>The Journal of Latin American Theology</em>, and <em>Christianity Today</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a1bd646